import { when } from "mobx";
import { observer } from "mobx-react";
import { Fragment, h } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";
import { FulfillmentSettingsTracking, t, Tracking, translate, PProductCardCreatorInput, } from "restaumatic-client";
import Alert from "../../components/Alert";
import AvailabilityDebugInfo from "../../components/AvailabilityDebugInfo";
import CrossSellingList from "../../components/CrossSellingList";
import FulfillmentMethodForm from "../../components/FulfillmentMethodForm";
import FulfillmentTimeBlock from "../../components/FulfillmentTimeBlock";
import { CART_MODAL_ID, showModal, switchModals } from "../../utils/Modals";
import { cartCrossSellingListView } from "../../utils/FieldTests/experiments/cartCrossSellingListView";
import FieldTests from "../../utils/FieldTests";
import FulfillmentTimeModal from "../Menu/FulfillmentTimeModal";
import CartProducts from "./CartProducts";
import CartPromotions from "./CartPromotions";
import CartSummaryRows from "./CartSummaryRows";
function CartBody(props) {
    const { cart, onChangeRestaurant, openProductCard } = props;
    const { fulfillmentFormController, fulfillmentTime } = cart;
    const [crossSellingVariant, setCrossSellingVariant] = useState("cards");
    const crossSellingItems = cart.crossSellingCreator.items.raw;
    const isImageVisible = Boolean(Number(Skubacz.configuration.theme_settings.cart_dish_images));
    const imageType = window.Skubacz.configuration.theme_settings.dish_image_style ===
        "rounded-circle"
        ? "circle"
        : "square";
    const editOrderLine = (orderLine) => openProductCard(PProductCardCreatorInput.editFromCart(orderLine));
    const showCrossSellingItem = (productInstance) => openProductCard(PProductCardCreatorInput.addFromCart(productInstance));
    useEffect(() => {
        return when(() => { var _a; return ((_a = cart.error) === null || _a === void 0 ? void 0 : _a.type) == "NotOverlappingDishes"; }, () => {
            Tracking.trackEvent({
                tag: "NotOverlappingDishes",
                contents: {
                    action: "not_overlapping_delivery_times_message",
                    category: "cart",
                    label: cart.restaurantName,
                },
            });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Try to assign user to the experiment when the cart is opened
    useEffect(() => {
        if (cart.isCartOpen) {
            FieldTests.apply(cartCrossSellingListView);
            const variant = FieldTests.getVariant(cartCrossSellingListView);
            if (variant === "TestBars") {
                setCrossSellingVariant("bars");
            }
            else {
                setCrossSellingVariant("cards");
            }
        }
    }, [cart.isCartOpen]);
    return (h(Fragment, null,
        cart.orderingHoursMessage !== null && (h(Alert, { type: cart.orderingHoursMessage.level, message: cart.orderingHoursMessage.message, fieldId: "cart.error" })),
        h("div", { class: "u-childs-separator" },
            h("div", null,
                h(CartProducts, { mode: { type: "editable", edit: editOrderLine }, items: cart.orderLines, isImageVisible: isImageVisible, imageType: imageType }),
                crossSellingVariant === "bars" && crossSellingItems.length > 0 && (h("div", { class: "u-mt4" },
                    h(CrossSellingList, { fieldId: "cart.crossSelling", variant: "bars", 
                        // TODO: translation
                        title: "Cz\u0119sto kupowane razem", items: crossSellingItems, openProductCard: (productInstance) => openProductCard(PProductCardCreatorInput.addFromCart(productInstance)) })))),
            h(CartPromotions, { fodState: cart.fodState, fodController: cart.fodFormController, promotions: cart.promotions, couponState: cart.couponState, cartMeetsCouponPromotionConditions: cart.cartMeetsCouponPromotionConditions }),
            fulfillmentFormController.isFulfillmentEditable &&
                cart.orderDetails.isFulfillmentEditable && (h(CartFulfillmentSettings, { fulfillmentFormController: fulfillmentFormController, fulfillmentMethodsOptions: cart.fulfillmentMethodsOptions, fulfillmentTime: fulfillmentTime, orderDetails: cart.orderDetails, deliveryAddressCoordinator: cart.deliveryAddressCoordinator, onChangeRestaurant: onChangeRestaurant }))),
        cart.error !== null && (h(Alert, { type: cart.error.level, message: cart.error.message, fieldId: "cart.error" })),
        h(AvailabilityDebugInfo, { name: "Cart", fieldId: "cart", availability: cart.availability }),
        h(CartSummaryRows, { deliveryPriceInCurrentZone: cart.deliveryPriceInCurrentZone, deliveryPriceAfterDiscounts: cart.deliveryPrice, packagingPrice: cart.packagingPrice }),
        crossSellingVariant === "cards" && crossSellingItems.length > 0 && (h(Fragment, null,
            h("hr", { class: "m-hr" }),
            h(CrossSellingList, { fieldId: "cart.crossSelling", variant: "cards", title: translate(t.crossup.title), items: crossSellingItems, openProductCard: showCrossSellingItem })))));
}
// TODO: DRY with Checkout.tsx
const CartFulfillmentSettings = observer((props) => {
    const { fulfillmentFormController, fulfillmentMethodsOptions, fulfillmentTime, orderDetails, deliveryAddressCoordinator, onChangeRestaurant, } = props;
    const fulfillmentTimeModalId = "cart-time";
    const editTimeBtnRef = useRef(null);
    const handleTimeModalOpen = () => void switchModals(CART_MODAL_ID, fulfillmentTimeModalId);
    const handleTimeSubmit = () => {
        FulfillmentSettingsTracking.chooseDateEvent({ tag: "Cart" });
    };
    const handleTimeModalHidden = () => {
        void showModal(CART_MODAL_ID).then(() => { var _a; return (_a = editTimeBtnRef.current) === null || _a === void 0 ? void 0 : _a.focus(); });
    };
    return (h("form", { class: "delivery is-editing" },
        h("h3", { class: "h5" }, translate(t.orders.form.fulfillment_options)),
        fulfillmentTime.isVisible && (h(Fragment, null,
            h(FulfillmentTimeBlock, { fulfillmentTime: fulfillmentTime, isRequired: false, editBtnRef: editTimeBtnRef, onEdit: handleTimeModalOpen }),
            h(FulfillmentTimeModal, { id: fulfillmentTimeModalId, dataFieldId: "Cart.fulfillmentTimeModal", modal: fulfillmentTime.modal, onShow: () => fulfillmentTime.touch(), onSubmit: handleTimeSubmit, onHidden: handleTimeModalHidden }))),
        h(FulfillmentMethodForm, { orderDetails: orderDetails, deliveryAddressCoordinator: deliveryAddressCoordinator, options: fulfillmentMethodsOptions, controller: fulfillmentFormController.fulfillmentMethodController, withApartmentInfo: false, withHiddenNoContactDelivery: false, onChangeRestaurant: onChangeRestaurant, origin: "Cart", viewType: "Cart" })));
});
export default observer(CartBody);
